import { render, staticRenderFns } from "./ClassifiedItemSkeleton.vue?vue&type=template&id=29670540&"
import script from "./ClassifiedItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports